import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { GetResource } from '@mdd/api';
import { GetCurrentUser } from '../domain/interactors/account';
import { FeatureSet, User } from '../domain/models';
import { NavGroup, Theme, Themer } from '../presentation/delegates';
import { MddHttpService } from './mdd-http.service';
import i18next from 'i18next';

@Injectable()
export class ThemeService implements Themer {
    private htmlElement: HTMLHtmlElement;
    private getCurrentUser: GetCurrentUser;
    private getFeatureSets: GetResource<User.Rel, FeatureSet[]>;

    constructor(@Inject(DOCUMENT) doc: Document, http: MddHttpService) {
        this.htmlElement = doc.querySelector('html')!;
        this.getCurrentUser = new GetCurrentUser(http);
        this.getFeatureSets = new GetResource(http);
        (window as any).dataLayer.push({ theme: this.getTheme() });
    }

    getTheme(): Theme {
        return <Theme>this.htmlElement.getAttribute('theme') || 'mdd';
    }

    setTheme(theme: Theme) {
        this.htmlElement.setAttribute('theme', theme);
    }

    getLogo(): string {
        return `/assets/images/logo-${this.getTheme()}.svg`;
    }

    getAltLogo(): string {
        if (this.getTheme().includes('dfa')) {
            return `/assets/images/logo-dfa-alt.svg`;
        }

        return this.getLogo();
    }

    showPoweredBy(): boolean {
        return this.getTheme() !== 'mdd';
    }

    hasPromo(): boolean {
        return false;
    }

    getPromo(): string {
        return `/assets/images/promo-${this.getTheme()}.png`;
    }

    getPromoAlt(): string {
        switch (this.getTheme()) {
            case 'dfa':
                return i18next.t('theme-service:get-promo-alt.dfa');
            default:
                return undefined!;
        }
    }

    getPromoHref(): string {
        switch (this.getTheme()) {
            case 'dfa':
                return 'https://www.mydairydashboard.com/dfamilk';
            default:
                return 'https://www.ever.ag/dairy/software-solutions/milk-plus/producer-portal/';
        }
    }

    getNavGroups(): NavGroup[] {
        const groups: NavGroup[] = [];
        switch (this.getTheme()) {
            case 'dfa':
                groups.push({
                    title: i18next.t('theme-service:nav-groups.dfa.title'),
                    items: [
                        {
                            title: i18next.t('theme-service:nav-groups.dfa.item.title'),
                            href: 'https://my.dfamilk.com',
                            icon: 'home',
                            sameTab: true
                        }
                    ]
                });

                break;
        }

        return groups;
    }

    canViewSettings(): Promise<boolean> {
        return this.getCurrentUser
            .execute()
            .then((user) => {
                if (user.canViewMenuSettings !== undefined) {
                    return user.canViewMenuSettings;
                } else {
                    return false;
                }
            })
            .catch(() => {
                // TODO: log error
                return false;
            });
    }
}
